import React, { useEffect, useState } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { ColumnCP } from 'submodules/nerit-framework-ui/common/components/grid/column/ColumnCP'
import { RowCP } from 'submodules/nerit-framework-ui/common/components/grid/row/RowCP'
import { SelectCP } from 'submodules/nerit-framework-ui/common/components/form-fields/select/SelectCP'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { WrapperFiltersCP } from 'submodules/nerit-framework-ui/features/common/components/filters/wrapper-filters/WrapperFiltersCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { ListResponseDTO } from 'submodules/nerit-framework-utils/sdk-utils/dtos/response/ListResponseDTO'
import { NameAndCodeResponseDTO } from 'submodules/nerit-framework-utils/sdk-utils/dtos/response/NameAndCodeResponseDTO'
import { MatrixRequests } from 'submodules/nerit-aquatec-sdk/services/matrix/MatrixRequests'
import { ParameterGroupRequests } from 'submodules/nerit-aquatec-sdk/services/parameter-group/ParameterGroupRequests'
import { SelectLocationCP } from 'common/components/form/SelectLocationCP'
import { SelectFieldCP } from 'modules/fields/components/select-field/SelectFieldCP'
import { SelectMatrixCP } from 'modules/collection-performance/components/selects/select-matrix/SelectMatrixCP'
import { SelectParameterGroupCP } from 'modules/collection-performance/components/selects/select-parameter-group/SelectParameterGroupCP'
import { ParameterControlFiltersFormModel } from 'modules/collection-performance/components/parameter-control/filters-parameter-control/inner/ParameterControlFiltersFormModel'
import { MonthRangeUtils } from 'modules/collection-performance/utils/MonthRangeUtils'

interface ICPProps {
    formStateManager: IFormStateManager<ParameterControlFiltersFormModel>
    onFilter: () => void
    isLoading?: boolean
}

/**
 * Filtros do Controle de Parametros (Tela 3.3). Matriz prefixa pontos e
 * Grupo de Parametros prefixa os parametros. Data e sempre um unico mes fechado.
 */
export function FiltersParameterControlCP(props: ICPProps): JSX.Element {

    const [yearOptions] = useState(() => MonthRangeUtils.getYearSelectOptions(new Date().getFullYear()))

    const matrixLocationsRequest = useRequest<ListResponseDTO<NameAndCodeResponseDTO>>()
    useEffect(onMatrixLocationsRequestChange, [matrixLocationsRequest.isAwaiting])

    const groupFieldsRequest = useRequest<ListResponseDTO<NameAndCodeResponseDTO>>()
    useEffect(onGroupFieldsRequestChange, [groupFieldsRequest.isAwaiting])

    /**
     */
    function onChangeMatrix(matrixCode?: number): void {
        if (!matrixCode)
            return

        matrixLocationsRequest.runRequest(MatrixRequests.getLocations(matrixCode))
    }

    /**
     */
    function onMatrixLocationsRequestChange(): void {

        if (!RequestUtils.isValidRequestReturn(matrixLocationsRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE))
            return

        const locations = matrixLocationsRequest.responseData?.list ?? []
        props.formStateManager.changeFieldValue('locationCodes', locations.map((location) => location.code))
    }

    /**
     */
    function onChangeParameterGroup(groupCode?: number): void {
        if (!groupCode)
            return

        groupFieldsRequest.runRequest(ParameterGroupRequests.getFields(groupCode))
    }

    /**
     */
    function onGroupFieldsRequestChange(): void {

        if (!RequestUtils.isValidRequestReturn(groupFieldsRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE))
            return

        const fields = groupFieldsRequest.responseData?.list ?? []
        props.formStateManager.changeFieldValue('fieldCodes', fields.map((field) => field.code))
    }

    return (
        <WrapperFiltersCP
            filters={
                <RowCP>
                    <ColumnCP size={5}>
                        <SelectMatrixCP
                            formStateManager={props.formStateManager}
                            fieldName={'matrixCode'}
                            onChange={onChangeMatrix}
                        />
                    </ColumnCP>
                    <ColumnCP size={6}>
                        <SelectLocationCP
                            isMany={true}
                            formStateManager={props.formStateManager}
                            fieldName={'locationCodes'}
                            isRequired={true}
                            maxTagCount={1}
                        />
                    </ColumnCP>
                    <ColumnCP size={5}>
                        <SelectParameterGroupCP
                            formStateManager={props.formStateManager}
                            fieldName={'parameterGroupCode'}
                            onChange={onChangeParameterGroup}
                        />
                    </ColumnCP>
                    <ColumnCP size={4}>
                        <SelectFieldCP
                            isMany={true}
                            formStateManager={props.formStateManager}
                            fieldName={'fieldCodes'}
                            isRequired={true}
                            maxTagCount={1}
                        />
                    </ColumnCP>
                    <ColumnCP size={2}>
                        <SelectCP
                            label={'Ano'}
                            required={true}
                            options={yearOptions}
                            formStateManager={props.formStateManager}
                            fieldName={'year'}
                        />
                    </ColumnCP>
                    <ColumnCP size={2}>
                        <SelectCP
                            label={'Mês'}
                            required={true}
                            options={MonthRangeUtils.getMonthSelectOptions()}
                            formStateManager={props.formStateManager}
                            fieldName={'month'}
                        />
                    </ColumnCP>
                </RowCP>
            }
            filterButton={
                <ButtonCP
                    icon={'search'}
                    type={'primary'}
                    onClick={props.onFilter}
                    loading={props.isLoading}
                />
            }
        />
    )
}
